import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { auto } from '@popperjs/core/lib';
import { CreateNEditPocComponent } from 'src/app/components/create-nedit-poc/create-nedit-poc.component';
import { ViewCommentsDialogComponent } from 'src/app/components/view-comments-dialog/view-comments-dialog.component';
import { AddProposalService } from '../../proposals/add-proposal/add-proposal.service';
import { GenAiMainService } from '../gen-ai-main.service';
import { DeleteDialogComponent } from 'src/app/components/delete-dialog/delete-dialog.component';
import { ToastrService } from 'ngx-toastr';
import { AuthServiceService } from 'src/app/services/auth-service.service';
import { GsdRoles } from 'src/app/enums/gsdRoles.enum';
import { Location } from '@angular/common';
import { ProposalRepositoryService } from '../../proposal-repository/proposal-repository.service';
import { MatPaginator } from '@angular/material/paginator';
import { ViewChild } from '@angular/core';
import { ExcelService } from 'src/app/services/excel-service.service';

@Component({
  selector: 'app-gen-ai-main',
  templateUrl: './gen-ai-main.component.html',
  styleUrls: ['./gen-ai-main.component.css']
})
export class GenAiMainComponent {
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  public searchText: string = '';
  public searchResultsViewFlag: boolean = false;
  gridView: boolean = false;
  loading: boolean = false;
  throttle = 300;
  distance = 2;
  rating = 0;
  stars = Array(5).fill(0);
  public serviceLinesForDropDown: any = [];
  public serviceOfferingForDropDown: any = [];
  public techStackForDropDown: any = [];
  public dataSource: MatTableDataSource<any>;
  selectedServiceLines: any[] = [];
  selectedServiceOfferings: any[] = [];
  selectedTechstack: any[] = [];
  public allPocList: any[];
  public totalPocCount: number;
  public loadingMore = false;
  public allDataLoaded = false;
  public totalRecords: number;
  public loader: boolean = false;
  public userEmail: string;
  public userId: Number;
  public recentlyAdded: any[];
  public recentlyViewed: any[];
  public topRated: any[];
  public recentlyAddedList: any[];
  public recentlyViewedList: any[];
  public topRatedList: any[];
serviceLineSearch: string = '';
filteredServiceLines = [];
serviceOfferingSearch: string = '';
filteredServiceOfferings = [];
techStackSearch: string = '';
filteredTechStacks = [];

  // public moreOrLess:string="more";
  public viewCount: number = 0;
  public ratedCount: number = 0;
  public pocRecords: any[];
  public from: number = 0;
  public size: number = 10;
  public gridRecords: any[];
  public searchAttempted: boolean = false;
  public filterAttempted: boolean = false;
  displayedColumns: string[] = ['Name', 'URL', 'Owner', "PointOfContact", "ServiceLine", "ServiceOffering", "TechTags", "Rating", "Actions"];
  role: string;
  // isLeadership: boolean;
  isSuperAdmin: boolean;
  admin: boolean;
  async ngOnInit() {
    this.userEmail = this._authService.getEmailId();
    this.userId = this._authService.getEmployeeId();
    this.role = this._authService.getRole();
    // if (this.role.includes(GsdRoles.Leadership)) {
    //   this.isLeadership = true;
    // }
    if (this.role.includes(GsdRoles.SuperAdmin)) {
      this.isSuperAdmin = true;
    }
    if (this.role.includes(GsdRoles.Admin)) {
      this.admin = true;
    }
    this.GetRecentlyViewedPocs();
    this.getTopRatedPocs();
    this.getServiceLinesForDropDown();
    this.getTechStack();
    this.dataSource = new MatTableDataSource();
    this.getAllPoc();
    this.getRecentData();
    this.dataSource = new MatTableDataSource<any>();
    this.filteredServiceLines = [...this.serviceLinesForDropDown];
    this.filteredServiceOfferings = [...this.serviceOfferingForDropDown];
    this.filteredTechStacks = [...this.techStackForDropDown];
  }
  // ngOnDestroy(): void {
  //   // Remove event listener when component is destroyed to prevent memory leaks
  //   document.removeEventListener('click', () => {
  //     document.querySelectorAll('.grid-dropdown-menu').forEach(menu => menu.classList.remove('show'));
  //   });
  // }
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  constructor(public dialog: MatDialog,
    public _service: AddProposalService,
    public pocService: GenAiMainService,
    private proposalService: ProposalRepositoryService,
    public toastr: ToastrService,
    public _authService: AuthServiceService,
    private _location: Location,
    private excel: ExcelService
  ) {
  }

  // rate(selectedRating: number) {
  //   if(selectedRating==this.rating)
  //   {
  //     this.rating=0;
  //   }
  //   else{
  //     this.rating = selectedRating;
  //   }
  // }
  searchButton() {
    this.resetScrollState();
    this.loading = true;
  this.searchAttempted = true;
  const hasFilters =
    this.selectedServiceLines.length > 0 ||
    this.selectedServiceOfferings.length > 0 ||
    this.selectedTechstack.length > 0;

  if (this.searchText?.trim()) {
    this.pocService.getSearchPOC(this.searchText).subscribe(res => {
      let records = res.pocResponse;

      if (hasFilters) {
        records = records.filter(item => {
        const matchServiceLine = this.selectedServiceLines.length === 0 ||
            this.selectedServiceLines.some(sl => item.serviceLine.includes(sl.name));
          const matchServiceOffering = this.selectedServiceOfferings.length === 0 ||
            this.selectedServiceOfferings.some(so => item.serviceOffering.includes(so.name));
          const matchTechStack = this.selectedTechstack.length === 0 ||
            this.selectedTechstack.some(ts => item.techStack.includes(ts.name));
          return matchServiceLine && matchServiceOffering && matchTechStack;
        });
      }

      this.pocRecords = records;
      this.dataSource.data = records;
      this.paginationData()
      this.loading = false;
    })
    }
    else {
      this.pocRecords = hasFilters ? this.filterItems() : this.allPocList;
      this.dataSource.data = this.pocRecords;
      this.paginationData()
    this.loading = false;
  }
  }
  clearSearch() {
    if (this.searchText == "") {
      this.searchButton();
    }
  }
  clearSearchText() {
    this.searchText = "";
    this.pocRecords = this.allPocList;
    this.paginationData();
    this.dataSource.data = this.allPocList;
    this.searchAttempted = false;
    this.selectedServiceLines = [];
    this.serviceLineSearch = '';
    this.serviceLineCheckEvent();  
    this.filterServiceLines();
    this.selectedServiceOfferings = [];
    this.serviceOfferingSearch = '';
    this.filterServiceOfferings();
    this.selectedTechstack=[];
    this.techStackSearch = '';
    this.filterTechStacks();
    this.getAllPoc();
  }

  viewRating(res) {
    const dialogRef = this.dialog.open(ViewCommentsDialogComponent, {
      width: auto,
      minWidth: '700px',
      height: auto,
      data: {
        pocData: res
      }
    })

    dialogRef.afterClosed().subscribe(result => {
      if (result.Status) {
        this.loader = true;
        var request = {
          EmpId: this.userId,
          EmpName: this.userEmail.split('@')[0].split('.').join(' '),
          Comment: result.Comment,
          Rating: result.Rating,
          CommentOn: new Date(),
          PocId: res.id
        }
        this.addRating(request);
      }
    });
  }
  addPOC() {
    const dialogRef = this.dialog.open(CreateNEditPocComponent, {
      disableClose: true,
      width: '840px',
      height: auto,
      data:
      {
        action: "Add"
      }
    })

    dialogRef.afterClosed().subscribe(data => {
      if (data == true) {
        setTimeout(() => {
          this.getAllPoc();
          this.getRecentData();
          this.resetScrollState();
          this.loading = true;
        }, 1000);
      }
      this.loading = false;
    })
  }
  editPOC(cardData) {
    const dialogRef = this.dialog.open(CreateNEditPocComponent, {
      disableClose: true,
      width: '840px',
      height: auto,
      data:
      {
        action: "Edit",
        editData: cardData
      }
    })

    dialogRef.afterClosed().subscribe(res => {
      if (res == true) {
        setTimeout(() => {
          this.getAllPoc();
          this.getRecentData();
          this.resetScrollState();
          this.loading = true;
        }, 1000);
      }
      this.loading = false;
    })
  }
  openOutlookEmail(email: string) {
    const mailtoLink = `mailto:${email}`;
    window.open(mailtoLink, '_blank');
  }
  getServiceLinesForDropDown(): Promise<any[]> {
    this.loading = true;
    return new Promise<any[]>((resolve, reject) => {
      this._service.getServiceAreas().subscribe(
        x => {
          x.data.forEach(tech => {
            const exists = this.serviceLinesForDropDown.some(line => line.name === tech.name);
            if (!exists) {
              this.serviceLinesForDropDown.push(tech);
            }
          });
          this.getServiceLinesForDropDownvalues(this.serviceLinesForDropDown);
          this.loading = false;
          resolve(this.serviceLinesForDropDown);
        },
        error => {
          this.loading = false;
          reject(error);
        }
      );
    });
  }
  

filterServiceLines() {
  const search = this.serviceLineSearch?.trim().toLowerCase() || '';
  if (search === '') {
    this.filteredServiceLines = [...this.serviceLinesForDropDown];
  } else {
    const filtered = this.serviceLinesForDropDown.filter(
      sl => sl.name.toLowerCase().includes(search)
    );

    const selected = this.selectedServiceLines.filter(
      sl => !filtered.some(f => f.id === sl.id)
    );
    this.filteredServiceLines = [...selected, ...filtered];
  }
}
filterServiceOfferings() {
  const search = this.serviceOfferingSearch?.trim().toLowerCase() || '';
  if (search === '') {
    this.filteredServiceOfferings = [...this.serviceOfferingForDropDown];
  } else {
    const filtered = this.serviceOfferingForDropDown.filter(
      so => so.name.toLowerCase().includes(search)
    );

    const selected = this.selectedServiceOfferings.filter(
      so => !filtered.some(f => f.name === so.name)
    );
    this.filteredServiceOfferings = [...selected, ...filtered];
  }
}
filterTechStacks() {
  const search = this.techStackSearch?.trim().toLowerCase() || '';
  if (search === '') {
    this.filteredTechStacks = [...this.techStackForDropDown];
  } else {
    const filtered = this.techStackForDropDown.filter(
      ts => ts.name.toLowerCase().includes(search)
    );

    const selected = this.selectedTechstack.filter(
      ts => !filtered.some(f => f.name === ts.name)
    );
    this.filteredTechStacks = [...selected, ...filtered];
  }
}



  getTopRatedPocs(): void {
    this.pocService.getTopRated(5).subscribe(res => {
      if (res.succeeded) {
        this.topRatedList = res.data;
      } else {
        console.error('Failed to load top rated POCs');
      }
    });
  } 


  getTechStack() {
    this.pocService.GetAllTechStack().subscribe(res => {
      const uniqueNames = new Set(this.techStackForDropDown.map(x => x.name.trim()));

      res.data.forEach(item => {
        const name = item.name.trimStart();
        if (!uniqueNames.has(name)) {
          uniqueNames.add(name);
          this.techStackForDropDown.push({ ...item, name });
        }
      });
      this.filteredTechStacks = [...this.techStackForDropDown];
      this.filterTechStacks();
    });
  }
  // getServiceOffering(): Promise<any[]> {
  //   this.loading = true;

  //   return new Promise<any[]>((resolve, reject) => {
  //     this._service.getserviceOffering().subscribe({
  //       next: (res) => {
  //         const existingNames = new Set(this.serviceOfferingForDropDown.map(x => x.name));

  //         res.data.forEach(tech => {
  //           if (!existingNames.has(tech.name)) {
  //             this.serviceOfferingForDropDown.push(tech);
  //             existingNames.add(tech.name);
  //           }
  //         });

  //         this.loading = false;
  //         resolve([...this.serviceOfferingForDropDown]); // return a shallow copy
  //       },
  //       error: (err) => {
  //         this.loading = false;
  //         reject(err);
  //       }
  //     });
  //   });
  // }
  async getAllPoc(callback?: () => void) {
    this.pocService.GetAllPoc().subscribe(res => {
      this.allPocList = res.pocResponse;
      this.totalRecords = res.totalCount;
      this.totalPocCount = res.totalCount;
      this.pocRecords = this.allPocList;
      this.gridRecords = this.pocRecords;
      this.dataSource.data = this.pocRecords;
      this.fetchImageUrl(this.pocRecords);
      if (callback) callback();
    });
  }

  GetRecentlyViewedPocs(){
    this.pocService.GetRecentlyViewedPocs().subscribe(res =>
      this.recentlyViewedList = res.slice(0, 5));
  }

  onScroll(): void {
    if (
      this.selectedServiceLines.length > 0 ||
      this.selectedServiceOfferings.length > 0 ||
      this.selectedTechstack.length > 0
    ) {
      return;
    }
    if (this.gridView || this.loadingMore || this.allDataLoaded) {
      return;
    }
    this.loadingMore = true;
    const previousLength = this.gridView ? this.dataSource.data.length : this.pocRecords.length;

    const newFrom = previousLength;

    this.pocService.getPaginationData(this.searchText, newFrom, this.size)
      .subscribe({
        next: (res) => {
          const newData = res.pocResponse;

          if (newData.length === 0) {
            this.allDataLoaded = true;
            return;
          }

          if (this.gridView) {
            this.dataSource.data = [...this.dataSource.data, ...newData];
          } else {
            this.pocRecords = [...this.pocRecords, ...newData];
          }
          this.loadingMore = false;
        },
        error: (err) => {
          console.error('Error loading more data:', err);
          this.loadingMore = false;
        }
      });
  }

  toggleView(type: string) {
    this.size = 10;
    if (type === 'table') {
      this.gridView = true;
      // this.size = 10;
    } else if (type === 'grid') {
      this.gridView = false;
      this.loadingMore = false;
      this.allDataLoaded = false;
    }
    this.getFilteredData();
  }

  private resetScrollState() {
    this.from = 0;
    this.loadingMore = false;
    this.allDataLoaded = false;
  }


  async fetchImageUrl(doc: any) {
    for (const records of doc || []) {
      if (records) {
        const Url = await this.getImage(records.logosharepointId);
        records.logoUrl = (Url) ? Url : 'assets/images/consulting.png';
      }
    };
  }
  async getImage(fileId: string): Promise<string> {
    return new Promise((resolve, reject) => {
      this.proposalService.getFileDownloadLink(fileId).subscribe(
        res => {
          if (res) {
            resolve(res.url);
          } else {
            reject('URL not found in response');
          }
        },
        err => reject(err)
      );
    });
  }

  async getRecentData() {
    this.pocService.GetAllPoc().subscribe(res => {
      this.recentlyAdded = res.pocResponse.sort((a, b) => new Date(b.createdOn).getTime() - new Date(a.createdOn).getTime())
      this.topRated = res.pocResponse.filter(x => x.ratingAverage != 0).sort((a, b) => b.ratingAverage - a.ratingAverage)
      this.ratedCount = this.topRated.length;
      this.recentlyViewed = res.pocResponse.filter(x => x.lastViewedOn != null).sort((a, b) => new Date(b.lastViewedOn).getTime() - new Date(a.lastViewedOn).getTime())
      this.viewCount = this.recentlyViewed.length;
      this.recentlyAddedList = this.recentlyAdded.slice(0, 10);
      // this.topRatedList = this.topRated.slice(0, 5);
      // this.recentlyViewedList = this.recentlyViewed.slice(0, 5);
    })
  }
  // openAddCommentDialog(data) {
  //   debugger
  //   const dialogRef = this.dialog.open(AddCommentDialogComponent, {
  //     width: auto,
  //     minWidth:'550px',
  //     height : auto
  //   })
  //   dialogRef.afterClosed().subscribe(result => {
  //     if (result.Status) {
  //       this.loader = true;
  //       var request={
  //         EmpId: this.userId,
  //         EmpName: this.userEmail.split('@')[0].split('.').join(' '),
  //         Comment:result.Comment,
  //         Rating:result.Rating,
  //         CommentOn: new Date(),
  //         PocId:data.id
  //     }
  //       this.addRating(request);
  //     }
  //   });

  // }

  addRating(data) {
    this.pocService.addRating(data).subscribe(res => {
      if (res.succeeded) {
        this.toastr.success("Rating Added Successfully")
        if (!this.gridView) {
          setTimeout(() => {
            this.getAllPoc();
            this.getRecentData();
            this.resetScrollState();
            this.getTopRatedPocs();
            this.loading = true;
          }, 1000);
        }
        else {
          const currentPageIndex = this.paginator.pageIndex;
          setTimeout(() => {
            this.getAllPoc(() => {
              this.paginator.pageIndex = currentPageIndex;
              this.paginator._changePageSize(this.paginator.pageSize);
            });
            this.getRecentData();
            this.resetScrollState();
            this.getTopRatedPocs();
            this.loading = true;
          }, 1000);
        }
      }
      else {
        this.toastr.error(res.message);
      }
    }
    );
  }
  openDeleteDialog(data) {
    const dialogRef = this.dialog.open(DeleteDialogComponent, {
      width: auto,
      minWidth: '550px',
      height: auto,
      data: {
        name: data.title,
        title: "Delete Proof of Concept"
      },
    })
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.loader = true;
        this.deletePocCard(data.id);
        this.getRecentData();
        this.resetScrollState();
      }
    });

  }
  delPocCard(data) {
    this.openDeleteDialog(data)
  }
  deletePocCard(id) {
    this.pocService.DeletePoc(id).subscribe((res) => {
      if (res.succeeded) {
        this.toastr.success("Details Deleted Successfully");
        if (!this.gridView) {
          setTimeout(() => {
            this.getAllPoc();
            this.getRecentData();
            this.resetScrollState();
            this.loading = true;
          }, 1000);
        }
        else {
          const currentPageIndex = this.paginator.pageIndex;
          setTimeout(() => {
            this.getAllPoc(() => {
              this.paginator.pageIndex = currentPageIndex;
              this.paginator._changePageSize(this.paginator.pageSize);
            });
            this.loading = true;
          }, 1000);
        }
      }
      else {
        this.toastr.error(res.message);
      }

    });

  }
  getServiceLinesForDropDownvalues(event: any) {
    if (!event || event.length === 0) {
      this.serviceOfferingForDropDown = [];
      this.selectedServiceOfferings = [];
      return;
    }
    this.filteredServiceLines = [...this.serviceLinesForDropDown];
    const selectedServiceLineIds = event.map((x: any) => x.id);
    const selectedCompetencyIds = event.map((x: any) => x.competencyId);

    // Remove outdated service offerings
    const selectedServiceOfferIds = new Set(selectedServiceLineIds);
    this.serviceOfferingForDropDown = this.serviceOfferingForDropDown.filter(item =>
      selectedServiceOfferIds.has(item.serviceId)
    );

    // Extract service offering HTML content and descriptions
    const listStartRegex = /\b1\./;

    const offerings = event.map((x: any) => {
      const serviceId = x.id;
      const descriptionHTML = x.serviceAreaInfo;
      const descriptionTooltipHTML = x.serviceAreaInfoDescription ?? x.serviceAreaInfo;

      const extractItems = (html: string): string[] => {
        const match = html?.match(/<p>([\s\S]*?)<\/p>/);
        if (match) {
          const startIndex = match[1].search(listStartRegex);
          if (startIndex !== -1) {
            const content = match[1].substring(startIndex);
            return content.split('<br/>').map(item => item.trim().replace(/^\d+\./, ''));
          }
        }
        return [];
      };

      return {
        serviceId,
        offerings: extractItems(descriptionHTML),
        tooltips: extractItems(descriptionTooltipHTML)
      };
    });

    // Flatten service offerings with corresponding tooltips
    let tooltipIndex = 0;
    const formattedOfferings = offerings.flatMap(o =>
      o.offerings.map(name => ({
        serviceId: o.serviceId,
        name,
        description: o.tooltips[tooltipIndex++] ?? ''
      }))
    );

    this.serviceOfferingForDropDown = formattedOfferings;
    this.selectedServiceOfferings = [];
    this.filteredServiceOfferings = [...this.serviceOfferingForDropDown];
  }

  toggleServiceLine(serviceLine: any) {
    this.serviceLineCheckEvent();
  }

  serviceLineCheckEvent() {
    if (this.selectedServiceLines.length === 0) {
      this.getServiceLinesForDropDownvalues(this.serviceLinesForDropDown);
    } else {
      this.getServiceLinesForDropDownvalues(this.selectedServiceLines);
    }

    this.getFilteredData();
    this.filterServiceLines();
  }

  toggleServiceOffering(serviceOffering: any) {
    this.getFilteredData();
    this.filterServiceOfferings();
  }

  toggleTechStack(techStack: any) {
    this.getFilteredData();
    this.filterTechStacks();
  }

  getFilteredData() {
    this.resetScrollState();
    const filtersActive = this.selectedServiceLines.length > 0 || this.selectedServiceOfferings.length > 0 || this.selectedTechstack.length > 0;
    this.filterAttempted = filtersActive;
    if (this.gridView === false) {
      this.pocRecords = this.filterItems();
    }
    else {
      this.dataSource.data = this.filterItems();
      this.totalRecords = !filtersActive
        ? this.totalPocCount
        : this.dataSource.data.length;
    }
  }
  // getMore(str)
  // {
  //   if(str=="Recently Added")
  //   {
  //     this.recentlyAddedList=this.recentlyAdded;
  //   }
  //   else if(str=="Recently Viewed")
  //   {
  //     this.recentlyViewedList=this.recentlyViewed;
  //   }
  //   else if(str=="Top Rated")
  //   {
  //     this.topRatedList=this.topRated;
  //   }

  //   this.moreOrLess="less"
  // }
  // getLess(str)
  // { this.moreOrLess="more"
  //   if(str=="Recently Added")
  //   {
  //     this.recentlyAddedList=this.recentlyAdded.slice(0,5);
  //   }
  //   else if(str=="Recently Viewed")
  //   {
  //     this.recentlyViewedList=this.recentlyViewed.slice(0,5);;
  //   }
  //   else if(str=="Top Rated")
  //   {
  //     this.topRatedList=this.topRated.slice(0,5);;
  //   }
  // }
  addLastViewedOn(poc) {
    var viewRequest = {
      PocId: poc.id,
      ViewedOn: new Date()
    }
    this.pocService.updateLastViewedOn(viewRequest).subscribe(res => {
      this.loading = true
      if (res) {
        if (!this.gridView) {
          setTimeout(() => {
            this.GetRecentlyViewedPocs();
            this.getRecentData();
            this.resetScrollState();
            this.loading = true;
          }, 1000);
        }
        else {
          const currentPageIndex = this.paginator.pageIndex;
          setTimeout(() => {
            this.getAllPoc(() => {
              this.paginator.pageIndex = currentPageIndex;
              this.paginator._changePageSize(this.paginator.pageSize);
            });
            this.loading = true;
          }, 1000);
        }

      }
      this.loading = false
    }
    )
  }

  navigateBack() {
    this._location.back();
  }

  async exportToExcel(): Promise<void> {
    this.from = 0;
    this.size = 10000;
    // this.paginationData();
    this.pocService.getPaginationData(this.searchText, this.from, this.size)
      .subscribe(res => {
        var exceldata = res.pocResponse;
        const modifiedItems = exceldata.map(item => ({
          Id: item.id,
          Title: item.title,
          Owner: item.owner,
          PointOfContact: item.pointofcontact,
          Url: item.url,
          ServiceLine: item.serviceLine.join(', '),
          ServiceOffering: item.serviceOffering.join(', '),
          TechStack: item.techStack.join(', '),
          Rating: item.ratingAverage,
          MetaData: item.metadata
        }));

        if (exceldata.length !== 0) {
          let fileName = 'ProofOfConceptsData';
          this.excel.exportAsExcelFile(modifiedItems, fileName);
        }
        else {
          this.toastr.error("No data available to export");
        }
      })
  }

  // toggleDropdown(event: MouseEvent): void {
  //   event.stopPropagation(); // Prevents event bubbling
  //   const dropdown = (event.target as HTMLElement).nextElementSibling as HTMLElement;

  //   if (dropdown) {
  //     const isVisible = dropdown.classList.contains('show');
  //     document.querySelectorAll('.grid-dropdown-menu').forEach(menu => menu.classList.remove('show')); // Close other dropdowns
  //     if (!isVisible) {
  //       dropdown.classList.add('show');
  //     }
  //   }
  // }

  filterItems(): any[] {
    const serviceLineSelected = this.selectedServiceLines.map(x => x.name);
    const serviceOfferingSelected = this.selectedServiceOfferings.map(x => x.name);
    const techStackSelected = this.selectedTechstack.map(x => x.name);
    if (this.selectedServiceLines.length === 0 && this.selectedServiceOfferings.length === 0 && this.selectedTechstack.length === 0) {
      return this.gridView ? this.gridRecords : this.allPocList;
    }
    else {
      const listToFilter = this.gridView ? this.gridRecords : this.allPocList;

      return listToFilter.filter(item => {
        const matchesServiceLine = serviceLineSelected.length != 0 && serviceLineSelected.some(sl => item.serviceLine.includes(sl));
        const matchesServiceOffering = serviceOfferingSelected.length != 0 && serviceOfferingSelected.some(so => item.serviceOffering.includes(so));
        const matchesTechStack = techStackSelected.length != 0 && techStackSelected.some(ts => item.techStack.includes(ts));

        // Only return true if item matches at least one selected filter
        return matchesServiceLine || matchesServiceOffering || matchesTechStack;
      });

    }
  }

  updatePageSize(newSize: number = 10) {
    this.from = 0;
    this.size = newSize;
    this.paginationData();
  }

  getPaginatorData(event) {
    if (event.previousPageIndex > event.pageIndex) {
      this.from = (event.pageIndex * this.size);
      this.size = event.pageSize;
    }
    else {
      this.size = event.pageSize;
      this.from = (event.pageIndex * this.size);
    }
    this.paginationData();
  }

  async paginationData() {
    this.pocService.getPaginationData(this.searchText, this.from, this.size)
      .subscribe(res => {
        // this.gridRecords=res.pocResponse;
        this.allPocList = res.pocResponse;
        this.dataSource.data = res.pocResponse;
        this.totalRecords = res.totalCount;
      })
  }

}
